module.exports = __webpack_public_path__ + "assets/img/cross.webp?3caae00955d83e32ce9b7a7013ba9430";